<template>
  <div>
    <a-dropdown
      placement="bottomLeft"
      trigger="hover"
    >
      <div class="px-2 cursor-pointer">
        <!-- <a-avatar
        :src="userStore.user?.headImg"
        size="small"
      /> -->
        <span class="ml-2">{{ userStore.user?.name }}{{ userStore.user?.activateGroup ? ` | ${userStore.user?.activateGroup.name}` : '' }}</span>
      <!-- <span class="ml-1 text-xs text-gray-500"> {{ userStore.user?.role.title }} </span> -->
      </div>
      <template #overlay>
        <a-menu @click="handleClickUserMenu">
          <a-menu-item key="resetPassword">
            <div class="flex items-center">
              <user-switch-outlined /> <span class="ml-2">修改登录密码</span>
            </div>
          </a-menu-item>
          <a-menu-item
            key="account"
          >
            <div class="flex items-center">
              <basic-icon name="icon-user-settings-line" /> <span class="ml-2">切换账号数据</span>
            </div>
          </a-menu-item>
          <!-- <a-menu-divider />
        <a-menu-item key="resetPayPassword">
          <div class="flex items-center">
            <user-switch-outlined /> <span class="ml-2">修改支付密码</span>
          </div>
        </a-menu-item> -->
          <a-menu-divider />
          <a-menu-item key="logout">
            <div class="flex items-center">
              <logout-outlined />
              <span class="ml-2">退出登录</span>
            </div>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
    <basic-modal
      v-bind="accountListModalAttrs"
      v-model:visible="accountListModalVisible"
    >
      <a-select
        v-model:value="defaultAccountId"
        class="w-full"
      >
        <a-select-option
          v-for="item in accountList"
          :key="item.id"
          :value="item.id"
        >
          <div class="flex items-center">
            <p class="text-lg font-semibold ml-1">
              {{ item.name }}
              <a-tag
                v-if="item.id === userStore.user?.activateGroupId"
                color="green"
              >
                默认
              </a-tag>
            </p>
          </div>
        </a-select-option>
      </a-select>
    </basic-modal>
  </div>
</template>

<script lang="ts" setup>
import { Modal } from 'ant-design-vue'
import { authApi } from '@/api/auth'
import { adminApi, clientApi } from '@/api/system'
import { useUserStore } from '@/store'
import { Rule } from 'ant-design-vue/es/form'
import globalModelForm from '@/hooks/global-model-form'
import { BasicModalProps } from '@/components/modal/prop'

const userStore = useUserStore()
const accountList = ref<Model.AdminUser []>([])
const defaultAccountId = ref(userStore.user?.activateGroupId === 0 ? userStore.user?.id : userStore.user?.activateGroupId)
const accountListModalVisible = ref<boolean>(false)

async function handleClickUserMenu({ key }) {

  switch (key) {
    case 'resetPassword':
      // 等待模态框渲染完再清空回填密码
      await globalModelForm.init({
        title: '修改登录密码',
        schemas: [
          {
            label: '真实姓名',
            field: 'name',
            component: 'Input',
            componentProps: {
              disabled: true,
            },
            required: true,
          } as IForm.Schema<'Input'>,
          {
            label: '登录密码',
            field: 'password',
            component: 'InputPassword',
            componentProps: {
              autocomplete: 'new-password',
            },
            required: true,
            rules: [
              {
                validator: (rule: Rule, value: string) => {
                  if (!value) {
                    return Promise.reject(new Error('密码不能为空'))
                  }
                  if (value.trim().length < 8 || value.trim().length > 15) {
                    return Promise.reject(new Error('密码长度不正确，请输入 8-15 位密码'))
                  }
                  return Promise.resolve()
                }
              }
            ],
          } as IForm.Schema<'InputPassword'>,
          {
            label: '二次确认登录密码',
            field: 'passwordConfirmation',
            component: 'InputPassword',
            required: true,
            componentProps: {
              autocomplete: 'new-password',
            },
            rules: [
              {
                trigger: 'blur',
                validator: (rule: Rule, value: string) => {
                  if (globalModelForm.formModel.password !== value) {
                    return Promise.reject(new Error('二次密码不一致，请重新输入'))
                  }
                  return Promise.resolve()
                },
              }
            ]
          } as IForm.Schema<'InputPassword'>,
          // {
          //   label: '验证码',
          //   field: 'captcha',
          //   component: 'InputCaptcha',
          // } as IForm.Schema<'InputCaptcha'>,
        ],
        model: userStore.user!,
        api: authApi.resetPassword,
        width: 480,
      })
      globalModelForm.formRef.setFormModel({ password: '' })
      break
      // case 'resetPayPassword':
      //   globalModelForm.init({
      //     title: '修改支付密码',
      //     schemas: [
      //       {
      //         label: '真实姓名',
      //         field: 'name',
      //         component: 'Input',
      //         componentProps: {
      //           disabled: true,
      //         },
      //         required: true,
      //       } as IForm.Schema<'Input'>,
      //       {
      //         label: '手机号码',
      //         field: 'mobile',
      //         component: 'Input',
      //         componentProps: {
      //           disabled: true,
      //           autocomplete: 'new-password',
      //         },
      //         required: true,
      //       } as IForm.Schema<'Input'>,
      //       {
      //         label: '支付密码',
      //         field: 'payPassword',
      //         component: 'InputPassword',
      //         componentProps: {
      //           autocomplete: 'new-password',
      //         },
      //         required: true,
      //         rules: [
      //           {
      //             validator: (rule: Rule, value: string) => {
      //               if (!value.trim()) {
      //                 return Promise.reject(new Error('支付密码不能为空'))
      //               }

      //               if (value.trim().length < 8 || value.trim().length > 15) {
      //                 return Promise.reject(new Error('支付密码长度不正确，请输入 8-15 位支付密码'))
      //               }

    //               return Promise.resolve()
    //             }
    //           }
    //         ],
    //       } as IForm.Schema<'InputPassword'>,
    //       {
    //         label: '二次确认支付密码',
    //         field: 'payPasswordConfirmation',
    //         component: 'InputPassword',
    //         componentProps: {
    //           autocomplete: 'false'
    //         },
    //         rules: [
    //           {
    //             required: true,
    //             trigger: 'blur',
    //             validator: (rule: Rule, value: string) => {
    //               if (globalModelForm.formModel.payPassword !== value) {
    //                 return Promise.reject(new Error('二次密码不一致，请重新输入'))
    //               }
    //               return Promise.resolve()
    //             },
    //           }
    //         ]
    //       } as IForm.Schema<'InputPassword'>,
    //       {
    //         label: '验证码',
    //         field: 'captcha',
    //         component: 'InputCaptcha',
    //       } as IForm.Schema<'InputCaptcha'>,
    //     ],
    //     model: userStore.user!,
    //     api: authApi.resetPayPassword,
    //     width: 480,
    //   })
    //   break
    case 'account':
      accountListModalVisible.value = true
      break
    case 'logout':
      Modal.confirm({
        title: '提醒',
        content: '确认退出登录吗？',
        onOk: async () => {
          await userStore.logout(true)
        },
      })
      break
    default:
      break
  }
}

const accountListModalAttrs = computed((): BasicModalProps => ({
  title: '切换账号数据',
  width: 480,
  okText: '确定',
  cancelText: '取消',
  destroyOnClose: true,
  onOk: async () => {
    try {
      await authApi.changeAccount({
        activateAccountId: defaultAccountId.value
      })
      location.reload()
    } finally {
      accountListModalVisible.value = false
    }
  },
  onCancel: () => {
    defaultAccountId.value = userStore.user?.id
    accountListModalVisible.value = false
  }
}))

const getAccountList = async () => {
  accountList.value = []
  accountList.value = await adminApi.getMyAdminUserList({
  })
  const currentUserId = userStore.user?.id
  accountList.value.sort((a, b) => {
    // 判断 a 和 b 是否是当前用户
    const isACurrentUser = a.id === currentUserId
    const isBCurrentUser = b.id === currentUserId

    // 如果 a 是当前用户，b 不是，a 排在前面
    if (isACurrentUser && !isBCurrentUser) {
      return -1
    } else if (!isACurrentUser && isBCurrentUser) {
      return 1
    } else {
      return 0
    }
  })
}
getAccountList()
</script>
